import { defineRecipe } from "@chakra-ui/react-v3";

export const skeletonRecipe = defineRecipe({
  base: {},

  variants: {
    loading: {
      true: {
        borderRadius: "sm",
        boxShadow: "none",
        backgroundClip: "padding-box",
        cursor: "default",
        color: "transparent",
        pointerEvents: "none",
        userSelect: "none",
        flexShrink: "0",

        "&::before, &::after, *": {
          visibility: "hidden",
        },
      },

      false: {
        background: "unset",
        animation: "fade-in {durations.extraFast} ease-out !important",
      },
    },
    variant: {
      shine: {
        "--animate-from": "200%",
        "--animate-to": "-200%",

        backgroundImage:
          "linear-gradient(270deg, {colors.neutral.subtle}, {colors.neutral.muted}, {colors.neutral.muted}, {colors.neutral.subtle})",
        backgroundSize: "400% 100%",
        animation: "bg-position {durations.ultraSlow} ease-in-out infinite",

        _motionReduce: {
          animation: "none",
        },
      },

      none: {
        animation: "none",
      },
    },
  },

  defaultVariants: {
    variant: "shine",

    loading: true,
  },
});
